import React, { useState } from "react";
import { fetchDataFromFirebase } from "../DatabaseFirebase/firebaseService";
import { invalidateLabelCache } from "../utils/labelMapping";

export const AuthContext = React.createContext({
  token: null,
  setUserToken: (token) => { },
  clearSession: () => { },
  user: null,
  customerUiInfo: null,
});

const AuthContextProvider = (props) => {
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const [isCurrentUserAdmin, setIsCurrentUserAdmin] = useState(
    JSON.parse(localStorage.getItem("isAdmin")) || false
  );
  const [authUserEmail, setAuthUserEmail] = useState(
    localStorage.getItem("authEmail") || ""
  );
  const [loggedInUser, setLoggedInUser] = useState(
    JSON.parse(localStorage.getItem("user"))
  );

  const [firebaseAuthUserData, setFirebaseAuthUserData] = useState(
    JSON.parse(localStorage.getItem("firebaseUser"))
  );

  const [customerUiInfo, setCustomerUiInfo] = useState(() => {
    const stored = localStorage.getItem("customer_ui_info");
    return stored ? JSON.parse(stored) : null;
  });

  const setUser = (token, loggedInUserEmail, user) => {
    fetchDataFromFirebase((data) => {
      if (data !== null) {
        const users = Object.values(data);
        const authUser = users.filter((user) => user.email === loggedInUserEmail);
        setFirebaseAuthUserData(authUser)
        localStorage.setItem("firebaseUser", JSON.stringify(authUser));
        if (authUser && authUser.length !== 0 && authUser[0]?.role === "admin") {
          setIsCurrentUserAdmin(true);
          localStorage.setItem("isAdmin", true);
        } else {
          setIsCurrentUserAdmin(false);
          localStorage.setItem("isAdmin", false);
        }
      }
    }, "Users");
    localStorage.setItem("token", token);
    const expiration = new Date();
    expiration.setHours(expiration.getHours() + 1)
    localStorage.setItem("expiration", expiration.toISOString())

    localStorage.setItem("authEmail", loggedInUserEmail);
    setToken(token);
    setAuthUserEmail(loggedInUserEmail);
    localStorage.setItem("user", JSON.stringify(user));
    setLoggedInUser(user);
    const uiInfo = user?.customer_ui_info || null;
    setCustomerUiInfo(uiInfo);
    localStorage.setItem("customer_ui_info", JSON.stringify(uiInfo));
    invalidateLabelCache(); 
  };

  const clearSession = () => {
    setUser(null);
    setCustomerUiInfo(null);
    localStorage.clear();
    sessionStorage.clear();
    invalidateLabelCache();
  };

  return (
    <AuthContext.Provider
      value={{
        token: token,
        setUser: setUser,
        clearSession: clearSession,
        isCurrentUserAdmin: isCurrentUserAdmin,
        authUserEmail: authUserEmail,
        user: loggedInUser,
        loggedInUser: firebaseAuthUserData,
        customerUiInfo: customerUiInfo,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
